import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import * as classroomActions from '../../../actions/classroom/classroomActions';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

class EnrollClassroomReveal extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.closeModal = this.closeModal.bind(this);
    this.enrollClassroomHandler = this.enrollClassroomHandler.bind(this);
    this.state = { enrollClass: '' };
  }

  static propTypes = {
    active: PropTypes.bool,
    classroomActions: PropTypes.object,
    colors: PropTypes.object
  };

  enrollClassroomHandler(e) {
    e.preventDefault();
    const { classroomActions } = this.props;
    let classCode = this.refs.enrollClassCode.value;
    if (classCode) {
      classroomActions.enrollClassroom(classCode).then(() => {
        this.refs.enrollClassCode.value = '';
        this.closeModal();
      });
    }
  }

  closeModal() {
    let { classroomActions } = this.props;
    classroomActions.setEnrollModalState(false);
  }

  render() {
    const { active, colors } = this.props;
    const { enrollClassCode } = this.state;

    return (
      <Modal
        id="enroll"
        title={I18n.t('home.student.empty.title')}
        active={active}
        onClickOutside={this.closeModal}
        children={
          <>
            <Paragraph className="text-grey-700">{I18n.t('home.student.empty.info')}</Paragraph>
            <input
              value={enrollClassCode}
              onChange={e => {
                this.setState({ enrollClassCode: e.target.value });
              }}
              type="text"
              ref="enrollClassCode"
              placeholder={I18n.t('home.student.empty.joinPlaceholder')}
            />
          </>
        }
        footer={
          <>
            <Button onClick={this.closeModal} label={I18n.t('common.cancel')}></Button>
            <Button onClick={this.enrollClassroomHandler} primary label={I18n.t('common.go')}></Button>
          </>
        }
      ></Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    active: state.classrooms.enrollModalIsOpen,
    colors: state.theme.colors,
    i18n: state.i18n
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EnrollClassroomReveal);
